const INDUSTRY_OPTIONS = {
  HOSPITALITY: 'hospitality',
  MANUFACTURING: 'manufacturing',
  HEALTHCARE: 'healthcare',
};

export default INDUSTRY_OPTIONS;
